import { CaptionedNichePersonImage, DetailsPanel } from '@/components/controls';
import { Map as MapIcon } from '@mui/icons-material';
import { Card, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { format } from 'date-fns';

export function AntiSocialBehaviourInstance({ instance, onShowMapClick }) {
  const { occurrence, aggrieved = [], subject } = instance;

  return (
    <Card variant="outlined" sx={{ minWidth: 240 }}>
      <Stack
        direction="row"
        spacing={1}
        sx={{ overflowX: 'auto', px: 1, pt: 1 }}
      >
        {subject?.id && <CaptionedNichePersonImage person={subject} />}
        {aggrieved.map((person) => (
          <CaptionedNichePersonImage key={person.id} person={person} />
        ))}
      </Stack>
      <Stack spacing={1} sx={{ p: 1 }}>
        <Stack
          direction="row"
          spacing={0.5}
          sx={{ alignItems: 'center', justifyContent: 'space-between' }}
        >
          <Typography
            variant="body3"
            color="textSecondary"
            sx={{ flexGrow: 1 }}
          >
            {occurrence?.number}
          </Typography>
          <Typography variant="subtitle2">
            {occurrence?.reportedTime &&
              format(occurrence.reportedTime, 'dd/MM/yyyy HH:mm')}
          </Typography>
        </Stack>
        {occurrence?.summary && (
          <Typography variant="body2" sx={{ p: 0.5 }}>
            {occurrence.summary}
          </Typography>
        )}
        <DetailsPanel
          title="Owned by"
          entries={[
            {
              label: 'OIC',
              value: occurrence?.officerInCase?.collarNumber,
            },
            {
              label: 'Team',
              value: occurrence?.officerInCase?.team,
            },
          ]}
        />
      </Stack>
      <Stack
        direction="row"
        spacing={1}
        sx={{ px: 1, pb: 1, justifyContent: 'flex-end', alignItems: 'center' }}
      >
        {occurrence?.address && (
          <Tooltip title="Show map">
            <IconButton size="small" onClick={onShowMapClick}>
              <MapIcon sx={{ fontSize: 'inherit' }} />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
    </Card>
  );
}
